import React, { useState, useEffect, Fragment } from "react";
import { ToastContainer, toast } from "react-toastify";
import "../App.css";

import { BrowserRouter as Router, Link, Route } from "react-router-dom";

export const DocConfig = ({ setAuth }) => {
  const [name, setName] = useState("");

  async function getName() {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard`,
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );
      const parsRes = await resp.json();
      // console.log(parsRes);

      setName(parsRes.emp_name);
    } catch (err) {
      console.error(err.message);
    }
  }

  // get employees list
  const [emps, setEmps] = useState([]);
  const fetchEmp = async () => {
    // Fetch the forms and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/employees`
    );
    const data = await response.json();

    setEmps(data);
    // console.log(forms);
  };

  // get document types list

  const [docs, setDocs] = useState([]);
  const fetchDocs = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/documents`
    );
    const data = await response.json();

    data.sort((a, b) => {
      const valueA = a.doc_type_id;
      const valueB = b.doc_type_id;
      if (valueA < valueB) {
        return -1;
      }
      if (valueA > valueB) {
        return 1;
      }

      return 0;
    });
    const filteredData = data.filter((doc) => {
      return doc.doc_type_id <= 6;
    }); setDocs(filteredData);
    // console.log(docs);
  };

  // get the approvers list

  const [approvers, setApprovers] = useState([]);
  const fetchAppro = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/approvers`
    );
    const data = await response.json();

    setApprovers(data);
    // console.log(approvers);
  };

  const setDocApprovers = async () => {
    // set document approvers
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/docApproversSet`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.token,
        },
        body: JSON.stringify(docApproversData),
      }
    );
  };

  useEffect(() => {
    // fetchEmp();
    getName();
    fetchDocs();
    fetchAppro();
    document.getElementById("doc-config-btn-submit").disabled = true;
  }, []);

  // handle document selection

  const [docApprover1, setDocApprover1] = useState(null);
  const [docApprover2, setDocApprover2] = useState(null);
  const [docApprover3, setDocApprover3] = useState(null);
  const [docApprover4, setDocApprover4] = useState(null);
  const [docApprover5, setDocApprover5] = useState(null);
  const [docApprover6, setDocApprover6] = useState(null);
  const [docApprover7, setDocApprover7] = useState(null);
  const [docApprover8, setDocApprover8] = useState(null);

  const [docApproversData, setDocApproversData] = useState({
    currentDocSend: null,
    docApprover1Send: null,
    docApprover2Send: null,
    docApprover3Send: null,
    docApprover4Send: null,
    docApprover5Send: null,
    docApprover6Send: null,
    docApprover7Send: null,
    docApprover8Send: null,
  });

  const [appTitle, setAppTitle] = useState(null);
  const handleDocumentSelection = (e) => {
    document.getElementById("doc-config-btn-submit").disabled = false;
    document.getElementById("appro_1").value = 0;
    document.getElementById("appro_2").value = 0;
    document.getElementById("appro_3").value = 0;
    document.getElementById("appro_4").value = 0;
    document.getElementById("appro_5").value = 0;
    document.getElementById("appro_6").value = 0;
    document.getElementById("appro_7").value = 0;
    document.getElementById("appro_8").value = 0;

    setAppTitle(0);
    for (let i = 0; i < docs.length; i++) {
      if (docs[i].doc_type_id == e.target.value) {
        setDocApprover1(docs[i].approver_1);
        setDocApprover2(docs[i].approver_2);
        setDocApprover3(docs[i].approver_3);
        setDocApprover4(docs[i].approver_4);
        setDocApprover5(docs[i].approver_5);
        setDocApprover6(docs[i].approver_6);
        setDocApprover7(docs[i].approver_7);
        setDocApprover8(docs[i].approver_8);
        setDocApproversData({
          ...docApproversData,
          currentDocSend: docs[i].doc_type_id,
        });

        // setPrivData({ ...privData, currentEmpSend: docs[i].emp_id});
      }
    }
  };

  useEffect(() => {
    setDocApproversData({
      ...docApproversData,
      docApprover1Send: docApprover1,
      docApprover2Send: docApprover2,
      docApprover3Send: docApprover3,
      docApprover4Send: docApprover4,
      docApprover5Send: docApprover5,
      docApprover6Send: docApprover6,
      docApprover7Send: docApprover7,
      docApprover8Send: docApprover8,
    });
  }, [docApproversData.currentDocSend]);

  const displayApproverTitle = (appId) => {
    for (let i = 0; i < approvers.length; i++) {
      if (approvers[i].app_id == appId) {
        return approvers[i].app_title;
      }
    }
  };
  // handle approvers selection

  const handleAppro1Selection = (e) => {
    for (let i = 0; i < approvers.length; i++) {
      if (e.target.value == 0) {
        setDocApproversData({ ...docApproversData, docApprover1Send: 0 });
        setDocApprover1(e.target.value);
      } else if (approvers[i].app_id == 0) {
        setDocApproversData({
          ...docApproversData,
          docApprover1Send: approvers[i].app_id,
        });
        setDocApprover1(approvers[i].app_id);
      } else {
        setDocApproversData({
          ...docApproversData,
          docApprover1Send: e.target.value,
        });
        setDocApprover1(e.target.value);
      }
    }
  };

  const handleAppro2Selection = (e) => {
    for (let i = 0; i < approvers.length; i++) {
      if (e.target.value == 0) {
        setDocApproversData({ ...docApproversData, docApprover2Send: 0 });
        setDocApprover2(e.target.value);
      } else if (approvers[i].app_id == e.target.value) {
        setDocApproversData({
          ...docApproversData,
          docApprover2Send: approvers[i].app_id,
        });
        setDocApprover2(approvers[i].app_id);
      } else {
        setDocApproversData({
          ...docApproversData,
          docApprover2Send: e.target.value,
        });
        setDocApprover2(e.target.value);
      }
    }
  };

  const handleAppro3Selection = (e) => {
    for (let i = 0; i < approvers.length; i++) {
      if (e.target.value == 0) {
        setDocApproversData({ ...docApproversData, docApprover3Send: 0 });
        setDocApprover3(e.target.value);
      } else if (approvers[i].app_id == e.target.value) {
        setDocApproversData({
          ...docApproversData,
          docApprover3Send: approvers[i].app_id,
        });
        setDocApprover3(approvers[i].app_id);
      } else {
        setDocApproversData({
          ...docApproversData,
          docApprover3Send: e.target.value,
        });
        setDocApprover3(e.target.value);
      }
    }
  };

  const handleAppro4Selection = (e) => {
    for (let i = 0; i < approvers.length; i++) {
      if (e.target.value == 0) {
        setDocApproversData({ ...docApproversData, docApprover4Send: 0 });
        setDocApprover4(e.target.value);
      } else if (approvers[i].app_id == e.target.value) {
        setDocApproversData({
          ...docApproversData,
          docApprover4Send: approvers[i].app_id,
        });
        setDocApprover4(approvers[i].app_id);
      } else {
        setDocApproversData({
          ...docApproversData,
          docApprover4Send: e.target.value,
        });
        setDocApprover4(e.target.value);
      }
    }
  };

  const handleAppro5Selection = (e) => {
    for (let i = 0; i < approvers.length; i++) {
      if (e.target.value == 0) {
        setDocApproversData({ ...docApproversData, docApprover5Send: 0 });
        setDocApprover5(e.target.value);
      } else if (approvers[i].app_id == e.target.value) {
        setDocApproversData({
          ...docApproversData,
          docApprover5Send: approvers[i].app_id,
        });
        setDocApprover5(approvers[i].app_id);
      } else {
        setDocApproversData({
          ...docApproversData,
          docApprover5Send: e.target.value,
        });
        setDocApprover5(e.target.value);
      }
    }
  };

  const handleAppro6Selection = (e) => {
    for (let i = 0; i < approvers.length; i++) {
      if (e.target.value == 0) {
        setDocApproversData({ ...docApproversData, docApprover6Send: 0 });
        setDocApprover6(e.target.value);
      } else if (approvers[i].app_id == e.target.value) {
        setDocApproversData({
          ...docApproversData,
          docApprover6Send: approvers[i].app_id,
        });
        setDocApprover6(approvers[i].app_id);
      } else {
        setDocApproversData({
          ...docApproversData,
          docApprover6Send: e.target.value,
        });
        setDocApprover6(e.target.value);
      }
    }
  };

  const handleAppro7Selection = (e) => {
    for (let i = 0; i < approvers.length; i++) {
      if (e.target.value == 0) {
        setDocApproversData({ ...docApproversData, docApprover7Send: 0 });
        setDocApprover7(e.target.value);
      } else if (approvers[i].app_id == e.target.value) {
        setDocApproversData({
          ...docApproversData,
          docApprover7Send: approvers[i].app_id,
        });
        setDocApprover7(approvers[i].app_id);
      } else {
        setDocApproversData({
          ...docApproversData,
          docApprover7Send: e.target.value,
        });
        setDocApprover7(e.target.value);
      }
    }
  };

  const handleAppro8Selection = (e) => {
    if (e.target.value == 0) {
      setDocApproversData({ ...docApproversData, docApprover8Send: 0 });
      setDocApprover8(e.target.value);
    } else
      for (let i = 0; i < approvers.length; i++) {
        if (approvers[i].app_id == e.target.value) {
          setDocApproversData({
            ...docApproversData,
            docApprover8Send: approvers[i].app_id,
          });
          setDocApprover8(approvers[i].app_id);
        } else {
          setDocApproversData({
            ...docApproversData,
            docApprover8Send: e.target.value,
          });
          setDocApprover8(e.target.value);
        }
      }
  };

  const handleDocConfSubmit = (e) => {
    e.preventDefault();
    setDocApprovers();
  };
  // console.log(emps[9].emp_level);

  //   console.log(docApproversData);

  return (
    <Fragment>
      <div className="config-doc-approval">
        <div className="documents-selection">
          <h5>Configurer les approbateurs d'un document</h5>

          <label className="label-control" for="documents">
            Sélectionner le document:
          </label>
          <select
            id="documents"
            className="documents-select form-control"
            onChange={handleDocumentSelection}
          >
            <option disabled selected value>
              {" "}
              -- selectionnez --{" "}
            </option>
            {docs.map((doc) => (
              <option key={doc.doc_type_id} value={doc.doc_type_id}>
                {doc.doc_tittle}
              </option>
            ))}
          </select>
        </div>

        <div className="privileges form-control">
          <div className="privilege-item ">
            <label className="label-control" for="approvers-container">
              Approbateurs:
            </label>
            <div
              id="doc-approvers-container"
              className="doc-approvers-container"
            >
              <div className="doc-approver-selection">
                <label className="approver1" for="approver1">
                  Approbateur #1:
                </label>
                <select
                  value={docApprover1}
                  id="appro_1"
                  className="appro_1 form-control"
                  onChange={handleAppro1Selection}
                >
                  <option disabled selected>
                    {" "}
                    {displayApproverTitle(docApprover1)}{" "}
                  </option>
                  <option value={0}> -------None------- </option>
                  {approvers.map((approver) => (
                    <option key={approver.app_id} value={approver.app_id}>
                      {approver.app_title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="doc-approver-selection">
                <label className="approver2" for="approver2">
                  Approbateur #2:
                </label>
                <select
                  value={docApprover2}
                  id="appro_2"
                  className="appro_2 form-control"
                  onChange={handleAppro2Selection}
                >
                  <option disabled selected>
                    {" "}
                    {displayApproverTitle(docApprover2)}{" "}
                  </option>
                  <option value={0}> -------None------- </option>
                  {approvers.map((approver) => (
                    <option key={approver.app_id} value={approver.app_id}>
                      {approver.app_title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="doc-approver-selection">
                <label className="approver3" for="approver3">
                  Approbateur #3:
                </label>
                <select
                  value={docApprover3}
                  id="appro_3"
                  className="appro_3 form-control"
                  onChange={handleAppro3Selection}
                >
                  <option disabled selected value>
                    {" "}
                    {displayApproverTitle(docApprover3)}{" "}
                  </option>
                  <option value={0}> -------None------- </option>
                  {approvers.map((approver) => (
                    <option key={approver.app_id} value={approver.app_id}>
                      {approver.app_title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="doc-approver-selection">
                <label className="approver4" for="approver4">
                  Approbateur #4:
                </label>
                <select
                  value={docApprover4}
                  id="appro_4"
                  className="appro_4 form-control"
                  onChange={handleAppro4Selection}
                >
                  <option disabled selected value>
                    {" "}
                    {displayApproverTitle(docApprover4)}{" "}
                  </option>
                  <option value={0}> -------None------- </option>
                  {approvers.map((approver) => (
                    <option key={approver.app_id} value={approver.app_id}>
                      {approver.app_title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="doc-approver-selection">
                <label className="approver5" for="approver5">
                  Approbateur #5:
                </label>
                <select
                  value={docApprover5}
                  id="appro_5"
                  className="appro_5 form-control"
                  onChange={handleAppro5Selection}
                >
                  <option disabled selected value>
                    {" "}
                    {displayApproverTitle(docApprover5)}{" "}
                  </option>
                  <option value={0}> -------None------- </option>
                  {approvers.map((approver) => (
                    <option key={approver.app_id} value={approver.app_id}>
                      {approver.app_title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="doc-approver-selection">
                <label className="approver6" for="approver6">
                  Approbateur #6:
                </label>
                <select
                  value={docApprover6}
                  id="appro_6"
                  className="appro_6 form-control"
                  onChange={handleAppro6Selection}
                >
                  <option disabled selected value>
                    {" "}
                    {displayApproverTitle(docApprover6)}{" "}
                  </option>
                  <option value={0}> -------None------- </option>
                  {approvers.map((approver) => (
                    <option key={approver.app_id} value={approver.app_id}>
                      {approver.app_title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="doc-approver-selection">
                <label className="approver7" for="approver7">
                  Approbateur #7:
                </label>
                <select
                  value={docApprover7}
                  id="appro_7"
                  className="appro_7 form-control"
                  onChange={handleAppro7Selection}
                >
                  <option disabled selected value>
                    {" "}
                    {displayApproverTitle(docApprover7)}{" "}
                  </option>
                  <option value={0}> -------None------- </option>
                  {approvers.map((approver) => (
                    <option key={approver.app_id} value={approver.app_id}>
                      {approver.app_title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="doc-approver-selection">
                <label className="approver8" for="approver8">
                  Approbateur #8:
                </label>
                <select
                  value={docApprover8}
                  id="appro_8"
                  className="appro_8 form-control"
                  onChange={handleAppro8Selection}
                >
                  <option disabled selected value>
                    {" "}
                    {displayApproverTitle(docApprover8)}{" "}
                  </option>
                  <option value={0}> -------None------- </option>
                  {approvers.map((approver) => (
                    <option key={approver.app_id} value={approver.app_id}>
                      {approver.app_title}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        <button
          id="doc-config-btn-submit"
          className="doc-config-btn-submit btn btn-primary"
          onClick={handleDocConfSubmit}
        >
          Mettre à jour les approbateurs
        </button>
      </div>
    </Fragment>
  );
};
